var render = function render(){var _vm=this,_c=_vm._self._c;return (!Array.isArray(_vm.data))?_c('div',{ref:"gaugeChart",staticClass:"gauge-chart",staticStyle:{"border":"1px solid #ececec","border-radius":"10px","box-shadow":"3px 3px 3px #ececec"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }